import { isInCategory, slugForCategory } from '../data/site.js'

// What to show under "Goes well with" on a product page.
//
// The owner's own picks (products.related) always come first. Anything still missing is
// filled automatically, and the automatic half deliberately reaches ACROSS categories:
// someone buying a shower screen needs seals, silicone and hinges, not another screen —
// that is the suggestion that grows the basket. Same-range products come after, so the
// section is never empty.

const COMPLEMENTS = {
  'Shower Screens': ['Hardware', 'Tools & Accessories'],
  '10mm Frameless Glass Panels': ['Hardware', 'Tools & Accessories'],
  'Wardrobe Doors': ['Tools & Accessories', 'Hardware'],
  Hardware: ['Tools & Accessories', '10mm Frameless Glass Panels'],
  'Tools & Accessories': ['Hardware', '10mm Frameless Glass Panels'],
}

const parseRelated = (product) => {
  try { return JSON.parse(product?.related || '[]') || [] } catch { return [] }
}

export function relatedProducts(product, all, limit = 4) {
  if (!product || !Array.isArray(all)) return []
  const pool = all.filter((p) => p.sku !== product.sku)
  const bySku = new Map(pool.map((p) => [p.sku, p]))
  const picked = []
  const take = (p) => {
    if (p && !picked.some((x) => x.sku === p.sku)) picked.push(p)
  }

  // 1. exactly what the owner chose, in their order
  parseRelated(product).forEach((sku) => take(bySku.get(sku)))

  // 2. the parts that go with it, from the complementary categories
  if (picked.length < limit) {
    const wanted = COMPLEMENTS[product.category] || []
    wanted.forEach((cat) => {
      const slug = slugForCategory(cat)
      pool.filter((p) => isInCategory(p, slug))
        .sort((a, b) => (b.featured - a.featured) || (a.sort - b.sort))
        .forEach(take)
    })
  }

  // 3. still short — stay in the same range so the row is always full
  if (picked.length < limit) {
    pool.filter((p) => p.subcategory && p.subcategory === product.subcategory).forEach(take)
    pool.filter((p) => p.category === product.category).forEach(take)
  }
  return picked.slice(0, limit)
}
